import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import hero1 from "../../assets/hero1.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import GetAppButton from "../../components/GetAppButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import hero2 from "../../assets/hero2.png";
import hero3 from "../../assets/hero3.png";
import hero4 from "../../assets/hero4.png";
import hero5 from "../../assets/hero5.png";
import hero6 from "../../assets/hero6.png";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import accessibilityhero from "../../assets/accessibilityhero.webp"
import { useNavigate } from "react-router-dom";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
const navigate=useNavigate()
const handleMore=()=>{
  navigate("/product-tour")
}
  const { links,} = useSocialLinks();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          px: isMobile ? 2 : 8,
          py: 6,
          backgroundColor: "#fff",
          gap: 8,
          marginTop: "70px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <CustomText
            style={{
              ...textStyles.h1,
              marginBottom: isMobile ? "0rem" : "1rem",
              marginTop: isMobile ? "0rem" : "1rem",
              fontSize: isMobile ? "36px" : "46px",
              textAlign: isMobile ? "center" : "left",

              // maxWidth:"400px"
            }}
          >
            {t("new_Accessibility_title")}
          </CustomText>

          <CustomText
            style={{
              ...textStyles.body1,
              color: "#868282",
              //  maxWidth: "1175px",
              margin: "0 auto",
              marginTop: "10px",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {t("new_Accessibility_subtitle")}
          </CustomText>
          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: "center",
              mt: isMobile ? "10px" : 4,
              gap: 1,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary"
              size="large"
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0,
                cursor:"pointer"
              }}
              onClick={handleMore}
            >
              <img
                src={more || "/placeholder.svg"}
                style={{ width: "65px", height: "65px" }}
              />
              <p
                style={{
                  color: hero_section_button_text.main,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  cursor: "pointer",
                }}
              >
                {t("Learn More")}
              </p>
            </Box>
          </Box>
        </Box>

 
      <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 4, md: 0 },
          }}
        >
          <Box
            component="img"
            src={accessibilityhero}
            alt="Dashboard Preview"
            sx={{
              width: "100%",
              maxWidth: "600px",
              height: "100%",
              display:"block"
            }}
          />
        </Box>

      </Box>
    </>
  );
};
export default HeroSection;
